module.exports = __webpack_public_path__ + "img/availableColors.d169fc0.jpg";